import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";


export const BookingRoomDataV4ListSchema = z.object({
    id: z.string().uuid(),
    payment_type: z.nullable(z.string()).optional(),
    channex_payment_collect: z.nullable(z.string()).optional(),
    property_id: z.string().uuid(),
    property_name: z.string(),
    channex_property_id: z.nullable(z.string()).optional(),
    customer_name: z.string(),
    customer_surname: z.nullable(z.string()),
    customer_email: z.nullable(z.string()),
    customer_phone: z.nullable(z.string()),
    customer_address: z.nullable(z.string()),
    customer_country: z.nullable(z.string()),
    customer_state: z.nullable(z.string()),
    customer_city: z.nullable(z.string()),
    customer_zip: z.nullable(z.string()),
    customer_date_of_birth: z.nullable(z.string()),
    customer_identity_number: z.nullable(z.string()),
    invoice_number: z.string(),
    voucher_number: z.nullable(z.string()).optional(),
    system_id: z.nullable(z.string()).optional(),
    invoice_date: z.string(),
    status: z.string(),
    mark: z.nullable(z.string()),
    agent_id: z.nullable(z.string().uuid()).optional(),
    room_type_id: z.nullable(z.string().uuid()),
    room_id: z.nullable(z.string().uuid()),
    rate_plan_id: z.nullable(z.string().uuid()),
    rates: z.array(z.object({
        date: z.string(),
        rate: z.union([z.string(), z.number()]).transform(v => String(v)),
    })),
    total_rate: z.union([z.string(), z.number()]).transform(v => String(v)),
    checkin_date: z.string(),
    checkout_date: z.string(),
    night: z.number(),
    adults: z.number(),
    children: z.number(),
    total_guests: z.number(),
    public_note: z.nullable(z.string()),
    private_note: z.nullable(z.string()),
    source: z.string(),
    b_id: z.nullable(z.string()).optional(),
    b_group_id: z.nullable(z.string().uuid()).optional(),
    channex_b_group_id: z.nullable(z.string()).optional(),
    channex_revision_id: z.nullable(z.string()).optional(),
    // Channex bisa mengirim guarantee sebagai string ATAU object (detail jaminan kartu).
    // Tidak ada komponen yang membaca field ini, jadi terima keduanya agar satu booking
    // ber-guarantee object tidak mematikan seluruh list reservasi.
    guarantee: z.union([z.string(), z.record(z.any())]).nullable().optional(),
    deposits: z.array(z.object({
        amount: z.union([z.string(), z.number()]).transform(v => String(v)),
        charged_at: z.string(),
        currency: z.string(),
        notes: z.string().nullable(),
        type: z.string(),
    })).nullable().optional(),
    ota_code: z.nullable(z.string()).optional(),
    ota_name: z.nullable(z.string()).optional(),
    ota_primary_color: z.nullable(z.string()).optional(),
    agent_name: z.nullable(z.string()).optional(),
    agent_email: z.nullable(z.string()).optional(),
    agent_phone: z.nullable(z.string()).optional(),
    agent_color: z.nullable(z.string()).optional(),
    agent_website: z.nullable(z.string()).optional(),
    created_at: z.string(),
    updated_at: z.string(),
    down_payment: z.union([z.string(), z.number()]).transform(v => String(v)).optional(),
    due_payment: z.union([z.string(), z.number()]).transform(v => String(v)).optional(),
    total_payments: z.union([z.string(), z.number()]).transform(v => String(v)).optional(),
    total_extras: z.union([z.string(), z.number()]).transform(v => String(v)).optional(),
    total_with_extras: z.union([z.string(), z.number()]).transform(v => String(v)).optional(),
    property: z.any().optional().nullable(),
    room_type: z.object({ id: z.string(), name: z.string() }).catchall(z.any()).optional().nullable(),
    room: z.object({ id: z.string(), room_number: z.string() }).catchall(z.any()).optional().nullable(),
    rate_plan: z.object({ id: z.string(), name: z.string() }).catchall(z.any()).optional().nullable(),
    agent: z.any().optional().nullable()
});

export const GetAllBookingResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(BookingRoomDataV4ListSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type BookingsResponseV4 = z.infer<typeof GetAllBookingResponseV4Schema>;
export type BookingV4 = z.infer<typeof BookingRoomDataV4ListSchema>;
